import React, { forwardRef } from "react"
import { Box, FormControl, FormHelperText } from "@mui/material"
import CustomAutoComplete from "./CustomAutoComplete"

// Use forwardRef to allow parent components to pass a ref
const SingleSelect = forwardRef((props, ref) => {
  const {
    controller,
    label,
    name,
    options,
    control,
    disabled = false,
    helperText,
    object = false,
    error = false,
    optionLabel,
    optionValue,
    onChange,
    loading = false,
    selectedValue,
    renderOptionContent,
    onInputChange,
  } = props

  const Controller = controller

  return (
    <Box className="w-full">
      <FormControl fullWidth error={!!error} className="w-full">
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <CustomAutoComplete
              className="w-full"
              ref={ref} // Forward the ref to CustomAutoComplete
              loading={loading}
              label={label}
              options={options}
              optionLabel={optionLabel}
              optionValue={optionValue}
              selectedValue={value || selectedValue}
              onChange={onChange}
              onInputChange={onInputChange}
              renderOptionContent={renderOptionContent}
              error={error}
              helperText={helperText}
              disabled={disabled}
            />
          )}
        />
      </FormControl>
    </Box>
  )
})

// Set the display name for debugging purposes
SingleSelect.displayName = "SingleSelect"

export default SingleSelect
